// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../common/Components/Label.bs.js");
let IconV5 = require("../common/Components/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Link = require("next/link").default;
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function UnifiedProfileSettingsUI$Header(props) {
  let __actions = props.actions;
  let actions = __actions !== undefined ? __actions : null;
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: props.title,
                className: "text-3xl font-medium leading-6 text-zinc-800"
              }),
              Stdlib_Option.getOr(Stdlib_Option.map(props.profileKind, kind => JsxRuntime.jsx(Label.Neutral.make, {
                text: kind
              })), null)
            ],
            className: "flex items-center gap-3"
          }),
          JsxRuntime.jsx("p", {
            children: props.description,
            className: "max-w-2xl text-base text-zinc-500"
          })
        ],
        className: "space-y-4"
      }),
      Stdlib_Option.getOr(Stdlib_Option.map(props.publicUrl, url => JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
        href: url,
        target: "_blank",
        children: "View Profile"
      })), null),
      actions
    ],
    className: "flex flex-col justify-between gap-8 border-b pb-6 lg:flex-row lg:items-end"
  });
}

let Header = {
  make: UnifiedProfileSettingsUI$Header
};

function UnifiedProfileSettingsUI$SubpageHeader(props) {
  let title = props.title;
  let breadcrumbs = [
    {
      name: props.rootName,
      href: props.rootUrl
    },
    {
      name: title,
      href: props.url
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: title,
        className: "text-3xl font-medium text-zinc-800"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let SubpageHeader = {
  make: UnifiedProfileSettingsUI$SubpageHeader
};

function UnifiedProfileSettingsUI$SettingsLink(props) {
  return JsxRuntime.jsxs(Link, {
    href: props.url,
    className: "flex items-center justify-between rounded-lg border border-zinc-200 p-4 hover:bg-zinc-50",
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: props.name,
            className: "text-base font-semibold text-zinc-800"
          }),
          JsxRuntime.jsx("div", {
            children: props.description,
            className: "text-zinc-600"
          })
        ],
        className: "space-y-2"
      }),
      JsxRuntime.jsx(IconV5.make, {
        icon: "arrow-right",
        className: "h-4 w-4 shrink-0 text-zinc-600"
      })
    ]
  });
}

let SettingsLink = {
  make: UnifiedProfileSettingsUI$SettingsLink
};

function UnifiedProfileSettingsUI$FormField(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.label
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsx("div", {
        children: props.children,
        className: "mt-2 space-y-3 sm:col-span-2 sm:mt-0 sm:max-w-xs"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let FormField = {
  make: UnifiedProfileSettingsUI$FormField
};

function UnifiedProfileSettingsUI$FormActions(props) {
  let __saveDisabled = props.saveDisabled;
  let __showSave = props.showSave;
  let __viewLabel = props.viewLabel;
  let viewLabel = __viewLabel !== undefined ? __viewLabel : "View Profile";
  let showSave = __showSave !== undefined ? __showSave : true;
  let saveDisabled = __saveDisabled !== undefined ? __saveDisabled : false;
  return JsxRuntime.jsxs("div", {
    children: [
      Stdlib_Option.getOr(Stdlib_Option.map(props.publicUrl, url => JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        href: Scalars.URL.toString(url),
        target: "_blank",
        children: viewLabel
      })), JsxRuntime.jsx("span", {})),
      showSave ? JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          disabled: saveDisabled,
          children: "Save changes"
        }) : null
    ],
    className: "flex items-baseline justify-between border-t border-zinc-200 pt-4"
  });
}

let FormActions = {
  make: UnifiedProfileSettingsUI$FormActions
};

function UnifiedProfileSettingsUI$ReadOnlyImageField(props) {
  let url = props.url;
  let label = props.label;
  let presentation;
  presentation = props.imageKind === "Logo" ? ({
      changeLabel: "Change logo",
      removeLabel: "Remove logo",
      emptyLabel: "Upload",
      imageClassName: "h-24 w-24 rounded-md object-contain",
      imageContainerClassName: "rounded-md border border-zinc-200 p-1"
    }) : ({
      changeLabel: "Change photo",
      removeLabel: "Remove photo",
      emptyLabel: "Select photo",
      imageClassName: "max-h-80 min-w-0 rounded object-contain",
      imageContainerClassName: ""
    });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__Label.make, {
            labelText: label
          }),
          JsxRuntime.jsx("small", {
            children: props.helpText,
            className: "text-base text-zinc-500"
          })
        ],
        className: "pt-2 sm:col-span-2"
      }),
      JsxRuntime.jsx("div", {
        children: url !== undefined ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("img", {
                  className: presentation.imageClassName,
                  alt: `Current ` + label.toLowerCase(),
                  src: url
                }),
                className: presentation.imageContainerClassName
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    disabled: true,
                    size: "small",
                    children: presentation.changeLabel
                  }),
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    disabled: true,
                    size: "small",
                    children: presentation.removeLabel
                  })
                ],
                className: "flex flex-col items-start gap-4"
              })
            ],
            className: "flex flex-col items-start gap-4 lg:flex-row lg:items-start lg:justify-between"
          }) : JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            disabled: true,
            size: "small",
            children: presentation.emptyLabel
          }),
        className: "mt-2 sm:col-span-3 sm:mt-0"
      })
    ],
    className: "space-y-6 py-6 sm:grid sm:grid-cols-5 sm:items-start sm:gap-16 sm:space-y-0"
  });
}

let ReadOnlyImageField = {
  make: UnifiedProfileSettingsUI$ReadOnlyImageField
};

exports.Header = Header;
exports.SubpageHeader = SubpageHeader;
exports.SettingsLink = SettingsLink;
exports.FormField = FormField;
exports.FormActions = FormActions;
exports.ReadOnlyImageField = ReadOnlyImageField;
/* Label Not a pure module */
